import { NavLink } from "react-router-dom";
import BrandLogo from "./BrandLogo";
import { useAuth } from "../context/AuthContext";

export default function ProductShell({ title, subtitle, action, children }) {
  const { userProfile } = useAuth();

  return (
    <div className="product-shell">
      <aside className="sidebar-shell">
        <div className="sidebar-brand">
          <BrandLogo compact />
        </div>

        <nav className="sidebar-nav">
          <NavLink className="sidebar-link" to="/dashboard">
            Dashboard
          </NavLink>
          <NavLink className="sidebar-link" to="/team">
            Team
          </NavLink>
          <NavLink className="sidebar-link" to="/billing">
            Billing
          </NavLink>
          <NavLink className="sidebar-link" to="/pricing">
            Upgrades
          </NavLink>
          {userProfile?.isAdmin ? (
            <NavLink className="sidebar-link" to="/admin">
              Admin
            </NavLink>
          ) : null}
        </nav>
      </aside>

      <div className="product-main">
        <header className="workspace-topbar">
          <div>
            <p className="workspace-overline">Creator Revenue Dashboard</p>
            <h1>{title}</h1>
            {subtitle ? <p className="workspace-subtitle">{subtitle}</p> : null}
          </div>
          {action ? <div className="workspace-action">{action}</div> : null}
        </header>

        {children}
      </div>
    </div>
  );
}
